import React, { useState } from 'react';
import ImageLoader from '../ImageLoader/ImageLoader';
import { Title100 } from '../Titles/Titles';
import PropTypes from 'prop-types';

import classes from './Portada.module.scss';

const Portada = props => {
    // const [imageStatus, setImageStatus] = useState(true);

    // const styles = {
    //             backgroundImage: `url(${props.imagenPrincipal}) `,
    //             'backgroundPosition': 'center', 
    //             'backgroundSize': 'cover', 
    //             'backgroundRepeat': 'no-repeat'
    //         }



    return (
        <div className={classes.Portada}>
            <ImageLoader className={classes.Image} imagenPrincipal={props.imagenPrincipal} objectFit={"none"} />
            <div className={classes.Title} style={{ backgroundColor: props.color }}>
                <Title100>
                    {props.titulo}
                </Title100>
            </div>
        </div>
    )
};

Portada.propTypes = {
    titulo: PropTypes.string.isRequired,
    imagenPrincipal: PropTypes.string.isRequired,
    color: PropTypes.string
}

export default Portada;